import BaseViewModel from "./BaseViewModel";


class FormViewModel extends BaseViewModel {

	FormElements: Array<BaseViewModel> = [];

	mediator = BaseViewModel.mediator;

	override Validate = () => {
		let valid = true;
		for ( let i = 0; i < this.FormElements.length; i++ ) {
			valid = this.FormElements[i].Validate() && valid;
		}
		return valid;
	};

	//
	getSimpleFormatXmlTagName = () => 'Form';

	getSimpleFormatXmlOpen = () => {
		let xml = '<' + this.getSimpleFormatXmlTagName() + ' idRef="' + this.LocalPath + '" title="' + this.elementDescriptor.Caption + '" ';
		if (this.LocalPath === '.')
			xml += 'xmlns="http://www.netvoxlab.com/dynamicforms/DFSimpleScheme.xsd"';
		return xml + '>';
	};

};

export default FormViewModel;
